import { combineReducers } from 'redux';
import { systemReducer } from './system/reducer';

const reducers = combineReducers({
    system: systemReducer,
});

export { reducers };

export type RootState = ReturnType<typeof reducers>;
